import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import PublicLogoLink from "../../components/PublicLogoLink";
import { loginToAccount } from "../../services/login";

export default function Login() {
    const navigate = useNavigate();

    const [form, setForm] = useState({
        email: "",
        password: "",
    });

    async function login() {
        const res = await loginToAccount(form);
        console.log(res);
        if (res.success) {
            var expirationDate = new Date(res.data.expirationDateTime);
            Cookies.set("Bearer", `Bearer ${res.data.token}`, {
                expires: expirationDate,
            });
            navigate("/my-assignments-report");
        } else {
            toast.error(res.message);
        }
    }

    useEffect(() => {
        if (typeof Cookies.get("Bearer") !== "undefined") {
            navigate("/");
        }
        // eslint-disable-next-line
    }, []);

    return (
        <section>
            <Toaster />
            <div className="flex h-screen overflow-hidden">
                {/* Sidebar */}
                {/* Content area */}
                <div className="relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto">
                    <header className="sticky top-0 z-30 bg-white border-b border-slate-200">
                        <div className="px-4">
                            <div className="flex items-center justify-between h-16 ">
                                <PublicLogoLink
                                    src="./logo_white.png"
                                    alt="logo"
                                    className="h-10"
                                />
                            </div>
                        </div>
                    </header>

                    <main>
                        <div className="flex items-center justify-center min-h-full px-4 py-12 sm:px-6 lg:px-8">
                            <div className="w-full max-w-md space-y-8">
                                <div>
                                    <div className="flex justify-center w-full">
                                        <PublicLogoLink
                                            src="./logo_white.png"
                                            alt="logo"
                                            className="h-40 w-100"
                                        />
                                    </div>
                                    <h2 className="mt-6 text-3xl font-extrabold text-center text-gray-900">
                                        Sign in
                                    </h2>
                                    {/* <p className="mt-2 text-sm text-center text-gray-600">
                                        Or{" "}
                                        <button
                                            onClick={() => navigate("/register")}
                                            className="font-medium text-teal-500 cursor-pointer hover:text-teal-400"
                                        >
                                            create an account
                                        </button>
                                    </p> */}
                                </div>
                                <div className="mt-8 space-y-6">
                                    <input
                                        type="hidden"
                                        name="remember"
                                        defaultValue="true"
                                    />
                                    <div className="-space-y-px rounded-md shadow-sm">
                                        <div>
                                            <label
                                                htmlFor="email-address"
                                                className="sr-only"
                                            >
                                                Email address
                                            </label>
                                            <input
                                                onChange={(e) =>
                                                    setForm({
                                                        ...form,
                                                        email: e.target.value,
                                                    })
                                                }
                                                id="email-address"
                                                name="email"
                                                type="email"
                                                autoComplete="email"
                                                required
                                                className="relative block w-full px-3 py-2 text-gray-900 placeholder-gray-500 border border-gray-300 rounded-none appearance-none rounded-t-md focus:outline-none focus:ring-teal-500 focus:border-teal-500 focus:z-10 sm:text-sm"
                                                placeholder="Email address"
                                            />
                                        </div>
                                        <div>
                                            <label
                                                htmlFor="password"
                                                className="sr-only"
                                            >
                                                Password
                                            </label>
                                            <input
                                                onKeyDown={(e) => {
                                                    if (e.code === "Enter") {
                                                        login();
                                                    }
                                                }}
                                                onChange={(e) =>
                                                    setForm({
                                                        ...form,
                                                        password: e.target.value,
                                                    })
                                                }
                                                id="password"
                                                name="password"
                                                type="password"
                                                autoComplete="current-password"
                                                required
                                                className="relative block w-full px-3 py-2 text-gray-900 placeholder-gray-500 border border-gray-300 rounded-none appearance-none rounded-b-md focus:outline-none focus:ring-teal-500 focus:border-teal-500 focus:z-10 sm:text-sm"
                                                placeholder="Password"
                                            />
                                        </div>
                                    </div>

                                    <div className="flex items-center justify-between">
                                        {/* <div className="flex items-center">
                                            <input
                                                id="remember-me"
                                                name="remember-me"
                                                type="checkbox"
                                                className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
                                            />
                                            <label htmlFor="remember-me" className="block ml-2 text-sm text-gray-900">
                                                Remember me
                                            </label>
                                        </div> */}

                                        <div className="text-sm">
                                            <a
                                                className="font-medium text-blue-500 hover:text-blue-400"
                                                onClick={() =>
                                                    navigate("/forgotPassword")
                                                }
                                            >
                                                Forgot your password?
                                            </a>
                                        </div>
                                    </div>

                                    <div>
                                        <button
                                            onClick={() => login()}
                                            onKeyDown={(e) => {
                                                if (e.code === "Enter") {
                                                    login();
                                                }
                                            }}
                                            className="relative flex justify-center w-full px-4 py-2 text-sm font-medium text-white bg-teal-500 border border-transparent rounded-md group hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                                        >
                                            <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="w-5 h-5 text-teal-500 group-hover:text-teal-400"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    stroke="currentColor"
                                                    strokeWidth={2}
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                                                    />
                                                </svg>
                                            </span>
                                            Sign in
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </section>
    );
}
